import React from 'react';
import PropTypes from 'prop-types';
import { Box, Button, CircularProgress } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: theme.spacing(6),
    display: 'flex'
  },
  submitBtn: {
    minWidth: 170,
  }
}));

const ClaimFormFooter = React.forwardRef(
  (
    {
      goBack,
      isFormSubmitting = false,
      isDisabled = false,
      nextButton = false,
      hideGoBack = false
    },
    ref
  ) => {
    const classes = useStyles();
    const { t } = useTranslation();

    const textForSubmitButton = nextButton
      ? t('claimFormFooter.next')
      : t('claimFormFooter.submit');

    return (
      <Box
        ref={ref}
        component="footer"
        className={classes.root}
      >
        {!hideGoBack && <Button
          onClick={goBack}
          size="large"
          variant="outlined"
        >
          {t('claimFormFooter.previous')}
        </Button>
        }
        <Box flexGrow={1} />
        <Button
          className={classes.submitBtn}
          color="secondary"
          type="submit"
          variant="contained"
          size="large"
          disabled={isDisabled || isFormSubmitting}
        >
          {
            isFormSubmitting
              ? <CircularProgress size={20} color="primary" />
              : textForSubmitButton
          }
        </Button>
      </Box>
    );
  }
)

ClaimFormFooter.displayName = 'ClaimFormFooter';
ClaimFormFooter.propTypes = {
  goBack: PropTypes.func,
  isFormSubmitting: PropTypes.bool,
  isDisabled: PropTypes.bool,
  nextButton: PropTypes.bool,
  hideGoBack: PropTypes.bool
};

ClaimFormFooter.defaultProps = {
  goBack: () => { }
};

export default ClaimFormFooter;
